module.exports = __webpack_public_path__ + "static/media/imac.81053dbb.jpg";